import React, { useState, useEffect, useCallback } from 'react';
//import axios from 'axios';
import Helmet from 'react-helmet';
import './GasCostCalculator.css'; // Import the CSS file for styling

const carData = [
  { name: 'Ford F-150 2024 (3.5L V6 EcoBoost)', mpg: 20 },
  { name: 'Chevrolet Silverado 1500 2024 (5.3L V8)', mpg: 17 },
  { name: 'Toyota RAV4 2024 (2.5L I4 Hybrid)', mpg: 40 },
  { name: 'Honda CR-V 2024 (1.5L Turbocharged I4)', mpg: 30 },
  { name: 'Toyota Camry 2024 (2.5L I4 Hybrid)', mpg: 52 },
  { name: 'Toyota Prius 2024 (2.0L I4 Hybrid)', mpg: 57 },
  { name: 'Nissan Rogue 2024 (1.5L Turbocharged I3)', mpg: 33 },
  { name: 'Hyundai Tucson 2024 (2.5L I4 Gasoline)', mpg: 28 },
  { name: 'Subaru Outback 2024 (2.5L Boxer I4 AWD)', mpg: 28 },
];

const GasCostCalculator = () => {
  const [mpg, setMpg] = useState(30); 
  const [distance, setDistance] = useState(1000);
  const [fuelPrices, setFuelPrices] = useState([]);
  const [costs, setCosts] = useState([]);
  const [selectedFuelType, setSelectedFuelType] = useState('gasoline');
  const [selectedCar, setSelectedCar] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: 'state', direction: 'ascending' });

  const calculateCosts = useCallback((prices, fuelType) => {
    const newCosts = prices.map((stateData) => {
      const monthlyCost = (distance / mpg) * parseFloat(stateData[fuelType]);
      const yearlyCost = monthlyCost * 12;
      return { state: stateData.name, monthlyCost: monthlyCost.toFixed(2), yearlyCost: yearlyCost.toFixed(2) };
    });

    setCosts(newCosts);
  }, [distance, mpg]);

  useEffect(() => {
    const fetchData = async () => {
      // Local fuel data
      const localFuelData = {
        "success": true,
        "result": [
          {
              "currency": "usd",
              "name": "Alaska",
              "gasoline": "3.477",
              "midGrade": "3.638",
              "premium": "3.895",
              "diesel": "3.578"
          },
          {
              "currency": "usd",
              "name": "Alabama",
              "gasoline": "2.793",
              "midGrade": "3.206",
              "premium": "3.595",
              "diesel": "3.386"
          },
          {
              "currency": "usd",
              "name": "Arkansas",
              "gasoline": "2.827",
              "midGrade": "3.242",
              "premium": "3.613",
              "diesel": "3.268"
          },
          {
              "currency": "usd",
              "name": "Arizona",
              "gasoline": "3.409",
              "midGrade": "3.759",
              "premium": "4.071",
              "diesel": "3.576"
          },
          {
              "currency": "usd",
              "name": "California",
              "gasoline": "4.852",
              "midGrade": "5.045",
              "premium": "5.228",
              "diesel": "5.024"
          },
          {
              "currency": "usd",
              "name": "Colorado",
              "gasoline": "3.083",
              "midGrade": "3.479",
              "premium": "3.803",
              "diesel": "3.378"
          },
          {
              "currency": "usd",
              "name": "Connecticut",
              "gasoline": "3.050",
              "midGrade": "3.664",
              "premium": "4.005",
              "diesel": "3.828"
          },
          {
              "currency": "usd",
              "name": "District of Columbia",
              "gasoline": "3.229",
              "midGrade": "3.779",
              "premium": "4.184",
              "diesel": "3.792"
          },
          {
              "currency": "usd",
              "name": "Delaware",
              "gasoline": "3.076",
              "midGrade": "3.599",
              "premium": "3.881",
              "diesel": "3.644"
          },
          {
              "currency": "usd",
              "name": "Florida",
              "gasoline": "3.072",
              "midGrade": "3.505",
              "premium": "3.822",
              "diesel": "3.609"
          },
          {
              "currency": "usd",
              "name": "Georgia",
              "gasoline": "2.986",
              "midGrade": "3.443",
              "premium": "3.839",
              "diesel": "3.551"
          },
          {
              "currency": "usd",
              "name": "Hawaii",
              "gasoline": "4.525",
              "midGrade": "4.761",
              "premium": "5.007",
              "diesel": "5.289"
          },
          {
              "currency": "usd",
              "name": "Iowa",
              "gasoline": "3.100",
              "midGrade": "3.301",
              "premium": "3.847",
              "diesel": "3.430"
          },
          {
              "currency": "usd",
              "name": "Idaho",
              "gasoline": "3.366",
              "midGrade": "3.607",
              "premium": "3.852",
              "diesel": "3.560"
          },
          {
              "currency": "usd",
              "name": "Illinois",
              "gasoline": "3.487",
              "midGrade": "4.054",
              "premium": "4.505",
              "diesel": "3.595"
          },
          {
              "currency": "usd",
              "name": "Indiana",
              "gasoline": "3.284",
              "midGrade": "3.787",
              "premium": "4.289",
              "diesel": "3.648"
          },
          {
              "currency": "usd",
              "name": "Kansas",
              "gasoline": "2.841",
              "midGrade": "3.156",
              "premium": "3.448",
              "diesel": "3.277"
          },
          {
              "currency": "usd",
              "name": "Kentucky",
              "gasoline": "2.854",
              "midGrade": "3.387",
              "premium": "3.803",
              "diesel": "3.286"
          },
          {
              "currency": "usd",
              "name": "Louisiana",
              "gasoline": "2.759",
              "midGrade": "3.180",
              "premium": "3.562",
              "diesel": "3.249"
          },
          {
              "currency": "usd",
              "name": "Massachusetts",
              "gasoline": "2.973",
              "midGrade": "3.572",
              "premium": "3.930",
              "diesel": "3.826"
          },
          {
              "currency": "usd",
              "name": "Maryland",
              "gasoline": "3.202",
              "midGrade": "3.781",
              "premium": "4.099",
              "diesel": "3.725"
          },
          {
              "currency": "usd",
              "name": "Maine",
              "gasoline": "3.016",
              "midGrade": "3.531",
              "premium": "3.978",
              "diesel": "3.939"
          },
          {
              "currency": "usd",
              "name": "Michigan",
              "gasoline": "3.256",
              "midGrade": "3.751",
              "premium": "4.303",
              "diesel": "3.529"
          },
          {
              "currency": "usd",
              "name": "Minnesota",
              "gasoline": "3.183",
              "midGrade": "3.571",
              "premium": "4.003",
              "diesel": "3.455"
          },
          {
              "currency": "usd",
              "name": "Missouri",
              "gasoline": "2.918",
              "midGrade": "3.263",
              "premium": "3.572",
              "diesel": "3.248"
          },
          {
              "currency": "usd",
              "name": "Mississippi",
              "gasoline": "2.685",
              "midGrade": "3.123",
              "premium": "3.489",
              "diesel": "3.229"
          },
          {
              "currency": "usd",
              "name": "Montana",
              "gasoline": "3.150",
              "midGrade": "3.440",
              "premium": "3.754",
              "diesel": "3.405"
          },
          {
              "currency": "usd",
              "name": "North Carolina",
              "gasoline": "2.892",
              "midGrade": "3.349",
              "premium": "3.735",
              "diesel": "3.511"
          },
          {
              "currency": "usd",
              "name": "North Dakota",
              "gasoline": "3.100",
              "midGrade": "3.394",
              "premium": "3.747",
              "diesel": "3.449"
          },
          {
              "currency": "usd",
              "name": "Nebraska",
              "gasoline": "3.063",
              "midGrade": "3.240",
              "premium": "3.697",
              "diesel": "3.329"
          },
          {
              "currency": "usd",
              "name": "New Hampshire",
              "gasoline": "2.893",
              "midGrade": "3.468",
              "premium": "3.878",
              "diesel": "3.784"
          },
          {
              "currency": "usd",
              "name": "New Jersey",
              "gasoline": "2.970",
              "midGrade": "3.539",
              "premium": "3.781",
              "diesel": "3.656"
          },
          {
              "currency": "usd",
              "name": "New Mexico",
              "gasoline": "3.014",
              "midGrade": "3.428",
              "premium": "3.727",
              "diesel": "3.431"
          },
          {
              "currency": "usd",
              "name": "Nevada",
              "gasoline": "3.926",
              "midGrade": "4.218",
              "premium": "4.496",
              "diesel": "3.830"
          },
          {
              "currency": "usd",
              "name": "New York",
              "gasoline": "3.123",
              "midGrade": "3.622",
              "premium": "4.008",
              "diesel": "3.943"
          },
          {
              "currency": "usd",
              "name": "Ohio",
              "gasoline": "3.136",
              "midGrade": "3.663",
              "premium": "4.169",
              "diesel": "3.513"
          },
          {
              "currency": "usd",
              "name": "Oklahoma",
              "gasoline": "2.764",
              "midGrade": "3.142",
              "premium": "3.434",
              "diesel": "3.147"
          },
          {
              "currency": "usd",
              "name": "Oregon",
              "gasoline": "3.842",
              "midGrade": "4.046",
              "premium": "4.288",
              "diesel": "3.895"
          },
          {
              "currency": "usd",
              "name": "Pennsylvania",
              "gasoline": "3.303",
              "midGrade": "3.750",
              "premium": "4.109",
              "diesel": "4.047"
          },
          {
              "currency": "usd",
              "name": "Rhode Island",
              "gasoline": "2.966",
              "midGrade": "3.694",
              "premium": "4.028",
              "diesel": "3.789"
          },
          {
              "currency": "usd",
              "name": "South Carolina",
              "gasoline": "2.816",
              "midGrade": "3.256",
              "premium": "3.624",
              "diesel": "3.368"
          },
          {
              "currency": "usd",
              "name": "South Dakota",
              "gasoline": "3.124",
              "midGrade": "3.317",
              "premium": "3.769",
              "diesel": "3.356"
          },
          {
              "currency": "usd",
              "name": "Tennessee",
              "gasoline": "2.794",
              "midGrade": "3.217",
              "premium": "3.611",
              "diesel": "3.378"
          },
          {
              "currency": "usd",
              "name": "Texas",
              "gasoline": "2.771",
              "midGrade": "3.212",
              "premium": "3.566",
              "diesel": "3.179"
          },
          {
              "currency": "usd",
              "name": "Utah",
              "gasoline": "3.257",
              "midGrade": "3.501",
              "premium": "3.716",
              "diesel": "3.470"
          },
          {
              "currency": "usd",
              "name": "Virginia",
              "gasoline": "3.005",
              "midGrade": "3.485",
              "premium": "3.847",
              "diesel": "3.585"
          },
          {
              "currency": "usd",
              "name": "Vermont",
              "gasoline": "3.109",
              "midGrade": "3.665",
              "premium": "4.068",
              "diesel": "3.818"
          },
          {
              "currency": "usd",
              "name": "Washington",
              "gasoline": "4.213",
              "midGrade": "4.438",
              "premium": "4.664",
              "diesel": "4.453"
          },
          {
              "currency": "usd",
              "name": "Wisconsin",
              "gasoline": "3.136",
              "midGrade": "3.595",
              "premium": "4.156",
              "diesel": "3.332"
          },
          {
              "currency": "usd",
              "name": "West Virginia",
              "gasoline": "3.002",
              "midGrade": "3.444",
              "premium": "3.876",
              "diesel": "3.587"
          },
          {
              "currency": "usd",
              "name": "Wyoming",
              "gasoline": "3.159",
              "midGrade": "3.427",
              "premium": "3.705",
              "diesel": "3.437"
          }
      ]
      };

      // Uncomment the following code to fetch data from the API in the future
      /*
      const apiKey = "apikey 2csC6QIls55hJ4XysMwFJI:0G6i0SXSlWUHO4bRtSXHdI";
      const headers = {
        "content-type": "application/json",
        "authorization": `apikey ${apiKey}`
      };

      try {
        const response = await axios.get("https://api.collectapi.com/gasPrice/allUsaPrice", { headers });
        if (response.data.success) {
          setFuelPrices(response.data.result);
          calculateCosts(response.data.result, selectedFuelType);
        } else {
          console.error(`Error in response data: ${response.data.message}`);
        }
      } catch (error) {
        console.error(`Error fetching data:`, error);
      }
      */

      // Use local data instead of API response
      if (localFuelData.success) {
        setFuelPrices(localFuelData.result);
        calculateCosts(localFuelData.result, selectedFuelType);
      } else {
        console.error(`Error in local data`);
      }
    };

    fetchData();
  }, [calculateCosts, selectedFuelType]);

  const handleSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const handleCarChange = (e) => {
    const selectedCarName = e.target.value;
    setSelectedCar(selectedCarName);
    const selectedCarData = carData.find(car => car.name === selectedCarName);
    if (selectedCarData) {
      setMpg(selectedCarData.mpg);
      calculateCosts(fuelPrices, selectedFuelType);
    }
  };

  const handleMpgChange = (e) => {
    setMpg(e.target.value);
    setSelectedCar('');
  };

  const sortedCosts = [...costs].sort((a, b) => {
    if (a[sortConfig.key] < b[sortConfig.key]) {
      return sortConfig.direction === 'ascending' ? -1 : 1;
    }
    if (a[sortConfig.key] > b[sortConfig.key]) {
      return sortConfig.direction === 'ascending' ? 1 : -1;
    }
    return 0;
  });

  return (
    <div className="page-container">
      <Helmet>
        <title>US Gas Price | Fuel Cost Calculator</title>
      </Helmet>
      <div className="content-wrap">
        <div className="gas-cost-calculator">
          <div className="input-container">
            <div className="input-group">
              <label>
                Average MPG:
                <input type="number" value={mpg} onChange={handleMpgChange} />
              </label>
              <label>
                Monthly Distance (miles):
                <input type="number" value={distance} onChange={(e) => setDistance(e.target.value)} />
              </label>
            </div>
            <label>
              <select value={selectedCar} onChange={handleCarChange}>
                <option value="">Select a car (optional)</option>
                {carData.map((car) => (
                  <option key={car.name} value={car.name}>
                    {car.name}
                  </option>
                ))}
              </select>
            </label>
            <button className="calculate-button" onClick={() => calculateCosts(fuelPrices, selectedFuelType)}>
              Calculate
            </button>
            <div className="fuel-type-buttons">
              <button
                className={`fuel-button ${selectedFuelType === 'gasoline' ? 'active' : ''}`}
                onClick={() => setSelectedFuelType('gasoline')}
              >
                Gasoline
              </button>
              <button
                className={`fuel-button ${selectedFuelType === 'midGrade' ? 'active' : ''}`}
                onClick={() => setSelectedFuelType('midGrade')}
              >
                MidGrade
              </button>
              <button
                className={`fuel-button ${selectedFuelType === 'premium' ? 'active' : ''}`}
                onClick={() => setSelectedFuelType('premium')}
              >
                Premium
              </button>
              <button
                className={`fuel-button ${selectedFuelType === 'diesel' ? 'active' : ''}`}
                onClick={() => setSelectedFuelType('diesel')}
              >
                Diesel
              </button>
            </div>
          </div>
          <table className="cost-table">
            <thead>
              <tr>
                <th onClick={() => handleSort('state')}>State</th>
                <th onClick={() => handleSort('monthlyCost')}>Monthly Cost</th>
                <th onClick={() => handleSort('yearlyCost')}>Yearly Cost</th>
              </tr>
            </thead>
            <tbody>
              {sortedCosts.map((cost) => (
                <tr key={cost.state}>
                  <td>{cost.state}</td>
                  <td>${cost.monthlyCost}</td>
                  <td>${cost.yearlyCost}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default GasCostCalculator;